<template>
  <div class="custom-control" :class="{ 'full-width': fullWidth }">
    <div class="custom-radio" :class="disabled ? 'disabled' : ''">
      <label :for="id" :disabled="disabled">
        <input
          :id="id"
          type="radio"
          class="custom-control-input"
          :disabled="disabled"
          :name="name"
          :checked="isChecked"
          :value="initialValue"
          @input="$emit('input', $event.target.value)"
          @change="handleChange"
        />
        <span class="form-check-label" :class="description ? 'fw-bold' : 'fw-normal'">
          {{ label }}
        </span>
        <span v-if="description" class="form-check-description">
          {{ description }}
        </span>
        <slot name="label"></slot>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
      required: false,
    },
    description: {
      type: String,
      default: '',
      required: false,
    },
    name: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      default: undefined,
    },
    initialValue: {
      default: undefined,
    },
    id: {
      type: String,
      default: '',
    },
    fullWidth: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      localValue: 'A',
    }
  },

  computed: {
    isChecked() {
      return this.localValue == this.initialValue
    },
  },

  watch: {
    value: {
      handler: function (modelValue) {
        if (modelValue === 'false') return (this.localValue = false)
        if (modelValue === 'true') return (this.localValue = true)

        this.localValue = modelValue
      },
      immediate: true,
    },
  },

  methods: {
    handleChange(event) {
      this.$emit('change', event.target)
    },
  },
}
</script>

<style lang="scss" scoped>
$form-check-radio-checked-disabled-bg-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'><circle cx='8' cy='8' r='8' stroke='#9EB4D3'/><circle cx='8' cy='8' r='4' fill='#9EB4D3'/></svg>");

.custom-control {
  &.full-width {
    width: 100%;
  }
}

.form-check-label {
  padding: 0px 0px 0px 8px;
}

.form-check-description {
  max-width: 256px;
  display: block;
  padding-left: 24px; /* Aligns with the text start */
  margin-left: 0;
}

.custom-radio {
  display: flex !important;

  &.disabled {
    opacity: 0.5;
  }

  label {
    display: block;
    position: relative;
    padding-left: 24px; /* Space for the radio button */

    .custom-control-input {
      position: absolute;
      left: 0;
      top: 3px;
      width: 16px;
      height: 16px;
      appearance: none;
      background-color: $form-check-input-bg;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      border: $form-check-input-border;
      margin: 0;

      &:hover {
        cursor: pointer;
      }

      &[type='radio'] {
        border-radius: $form-check-radio-border-radius;
        &:focus {
          outline: none;
          box-shadow: $blue-100 0px 1px 3px 0px, $blue-100 0px 0px 0px 1px;
        }
      }

      &:checked {
        background-color: $form-check-input-checked-bg-color;
        border-color: $form-check-input-checked-border-color;

        &[type='radio'] {
          background-color: $mep-primary;
          border-color: $mep-primary-400;
          background-image: escape-svg($form-check-radio-checked-bg-image);
        }
      }

      &:checked[disabled] {
        background-color: white;
        border-color: #9eb4d3;
        &[type='radio'] {
          background-image: escape-svg($form-check-radio-checked-disabled-bg-image);
        }
      }
    }

    .form-check-label {
      display: inline-block;
      padding-left: 0;
    }

    .form-check-description {
      display: block;
      max-width: 256px;
      margin-left: 0;
      margin-top: 4px;
    }
  }
}
</style>
